<template>
    <section>
      <stockTopMenu curPosition="店员管理" windowId="employeeManage" module="employManage">
        <div
          slot="descript"
          class="row align-center space-between"
          style="margin-left: 100px"
        ></div>
      </stockTopMenu>
      <!-- body -->
      <div style="display: flex;justify-content:space-between;">
        <div style="margin:10px;">
          <userList @record="handelRecord" :loadingUserInfo="loadingUserInfo"></userList>
        </div>
        <div style="margin:10px 10px 10px 0;width:100%;padding:20px; height:92vh; background-color: #ffffff">
          <div v-if="record">
            <div style="font-size: 25px;margin-bottom: 10px">{{record.userName}}</div>
            <div style="margin-bottom: 10px;color:#737373;">
              <span>{{record.sex==='1' ? '男' : '女'}}</span>
              <el-divider direction="vertical"></el-divider>
              <span>{{record.age}}岁</span>
              <el-divider direction="vertical"></el-divider>
              <span>{{record.highestEducation}}</span>
              <el-divider direction="vertical"></el-divider>
              <span>{{record.maritalStatus==='0'?'未婚':'已婚'}}</span>
            </div>
          </div>
          <el-tabs v-model="activeName" @tabClick="handelClick">
            <el-tab-pane label="员工资料" name="userInfo">
              <userInfo :record="record" @loadingUserInfo="loadingUserInfoClick"></userInfo>
            </el-tab-pane>
            <el-tab-pane label="人员轨迹" name="flowTrack">
              <flowTrack :record="record" @loadingUserInfo="loadingUserInfoClick"></flowTrack>
            </el-tab-pane>
          </el-tabs>

        </div>
      </div>
      
    </section>
  </template>
  <script>
  import stockTopMenu from "@/components/stockTopMenu.vue";
  import userList from './components/userList.vue'
  import flowTrack from "./components/flowTrack.vue"
  import userInfo from "./components/userInfo.vue"
  import moment from 'moment'
  import newPostUrl from '@/libs/http/modules/oa.js'
  import tool from '@/utils/tool.js'

  export default {
    name: "employeeManage",
    components: {
      stockTopMenu,
      userList,
      flowTrack,
      userInfo,
    },
    data() {
      return {
        loading:false,
        record:null,
        indexTab:'0',
        activeName:'userInfo',
        loadingUserInfo:false,
      };
    },
    created () {

    },
    methods: {
      handelRecord(e){
        console.log('================',e)
        this.record = e
      },
      handelClick(e){
        if(e.index==='0'){

        }
      },
      loadingUserInfoClick(e){
        console.log('eeeeeeeee',e)
        this.loadingUserInfo = e
      }

    },
  };
  </script>
  
<style lang='scss' scoped>
.clickTop{
    height:40px;
    line-height: 40px;
    font-size: 14px;
    width:100px;
    text-align: center;
}
.clickTopActive{
    border-bottom: 3px solid #1684fc;
    color:#1684fc;
}
.dataStateStyle{
  display: flex;
  justify-content:center;
  align-items: center;
  background-color: #fff;
  height:82vh;
  width:100%;
  color:#ccc;
  font-size:30px;
}
  </style>